import Experiments from '@/api/experiments/experiments.js';
import fileDownload from "js-file-download";
import router from "@/router";

const experiments = new Experiments();

const experimentsModule = {
  namespaced: true,
  state: {
    items: [],
    item: null,
    lookups: [],
    subExperimentsLookups: [],
    total: 0,
    load: false,
    loadItem:false,
  },
  getters: {
    items(state) {
      return state.items;
    },
    item(state) {
      return state.item;
    },
    load(state) {
      return state.load;
    },
    loadItem(state) {
      return state.loadItem;
    },
    total(state) {
      return state.total;
    },
    lookups(state) {
      return state.lookups;
    },
    subExperimentsLookups(state) {
      return state.subExperimentsLookups;
    },
  },
  mutations: {
    SET_ITEMS: (state, experiments) => {
      state.items = experiments;
    },
    SET_TOTAL_EXPERIMENTS: (state, total) => {
      state.total = total;
    },
    SET_ITEMS_LOAD: (state, load) => {
      state.load = load;
    },
    SET_ITEM: (state, school) => {
      state.item = school;
    },
    SET_LOAD_ITEM: (state, loadItem) => {
      state.loadItem = loadItem;
    },
    SET_LOOKUPS(state, lookups) {
      state.lookups = lookups;
    },
    SET_SUBEXPERIMENTS_LOOKUPS(state, lookups) {
      state.subExperimentsLookups = lookups;
    },
  },
  actions: {
    list({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_ITEMS_LOAD', true);
        experiments.list().then(response => {
          commit('SET_ITEMS', response.data);
          commit('SET_ITEMS_LOAD', false);
          resolve(response);
        });
      });
    },
    put({ commit }, payload) {
      return new Promise((resolve, reject) => {
        experiments
          .put(payload)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    update({ commit }, payload) {
      return new Promise((resolve, reject) => {
        experiments
          .update(payload)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    lookups({ commit }) {
      return new Promise((resolve, reject) => {
        experiments.lookups().then(response => {
          commit('SET_LOOKUPS', response.modules);
          resolve();
        });
      });
    },
    subExperimentsLookups({ commit }) {
      return new Promise((resolve, reject) => {
        experiments.subExperimentsLookups().then(response => {
          commit('SET_SUBEXPERIMENTS_LOOKUPS', response.topic_types);
          resolve();
        });
      });
    },
    get({ commit , dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('SET_ITEM', null);
        commit('SET_LOAD_ITEM', true);
        experiments.get(id)
          .then(response => {
            commit('SET_ITEM', response.data);
            commit('SET_LOAD_ITEM', false);
            resolve(response);
          })
          .catch(error => {
            reject(error);
            commit('SET_LOAD_ITEM', false);
          });
      });
    },
    remove({ commit }, id) {
      return new Promise((resolve, reject) => {
        experiments
          .remove(id)
          .then(response => {
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    restore({ commit }, id) {
      return new Promise((resolve, reject) => {
        experiments
          .restore(id)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    order({ commit }, payload) {
      return new Promise((resolve, reject) => {
        experiments
          .order(payload)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    watched({ commit }, payload) {
      return new Promise((resolve, reject) => {
        experiments
          .watched(payload)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    hardRemove({ commit }, id) {
      return new Promise((resolve, reject) => {
        experiments
          .hardRemove(id)
          .then(response => {
            
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};

export default experimentsModule;
